import React from 'react'
import {
  PENDINGTPVLISTCONFIGS,
  PENDINGTPVLISTFILTERCONFIG,
} from '../../../../utils/QCAdmin/pendingTPVListUtils'
import SearchList from '../../../sharedComponent/SearchList/SearchList'
import Filter from '../../../sharedComponent/Filter'

import {filterOptions} from '../../../../utils/Global.types'

type pendingTpvList = {
  filterOptions: filterOptions
  tpvListLoading: boolean
  tpvRecordingData: any
  setFilterOptions: React.Dispatch<React.SetStateAction<filterOptions>>
  initialFilter: filterOptions
  openQcEdit: any
}
export default function PendingTPVList({
  filterOptions,
  tpvListLoading,
  tpvRecordingData,
  setFilterOptions,
  initialFilter,
  openQcEdit,
}: pendingTpvList) {
  return (
    <SearchList
      idFieldName='id'
      filterOptions={filterOptions}
      setFilterOptions={setFilterOptions}
      listCount={tpvRecordingData?.getAllTpvs?.totalCount}
      paginatedCount={tpvRecordingData?.getAllTpvs?.tpvs.length}
      listLoading={tpvListLoading}
      apiData={tpvRecordingData?.getAllTpvs?.tpvs}
      listConfigs={PENDINGTPVLISTCONFIGS}
      isSearchable={false}
      toolbar={
        <Filter
          filterConfig={PENDINGTPVLISTFILTERCONFIG}
          filterOptions={filterOptions}
          initialFilter={initialFilter}
          setFilterOptions={setFilterOptions}
          colors='white'
        />
      }
      onRowClick={openQcEdit}
      cardHeader={
        <div className='d-flex flex-column position-relative my-1'>
          <h6 className='fs-3 fw-bolder text-gray-900'>Pending QC Review</h6>
          <div>
            <span className='text-gray-800 fw-bold fs-7'>
              {tpvRecordingData?.getAllTpvs.totalCount}
            </span>
            <span className='text-gray-400 ms-2 fs-7'>TPVs</span>
          </div>
        </div>
      }
      isActiveApiFieldName=''
    />
  )
}
